/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

const dataSchema = z.object({ dismissed: z.literal(true) });

export const dismissChallengeIssueResponseSchema = createApiResponseSchema(
  dataSchema,
) as z.ZodSchema<IAPI<{ dismissed: true }>>;

export type IDismissChallengeIssueResponse = IAPI<{ dismissed: true }>;
